import CountryFlag from 'components/general/CountryFlag/CountryFlag';
import Link from 'components/general/Link/Link';
import React from 'react';

const GeographySummary: React.SFC<GeographySummaryPropDef> = ({
  iso,
  slug,
  title,
}) => (
  <article className="geography-summary" data-test="geography-summary">
    <div className="geography-summary__flag">
      <CountryFlag iso={iso ? iso.toLowerCase() : null} />
    </div>
    <h2 className="geography-summary__title">
      <Link
        to={{
          type: 'COUNTRIES_GEOGRAPHY',
          payload: { geography: slug },
        }}
      >
        {title}
      </Link>
    </h2>
  </article>
);

export interface GeographySummaryPropDef {
  title: string;
  slug: string;
  iso?: string;
}

export default GeographySummary;
